import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';

import { Subscription } from "rxjs";

import { DynamicDialogService } from "../../../core/services/dynamic-dialog.service";
import { Dialog, DialogButton } from "../../../core/models/dialog.model";
import { SubHeaderService } from "../../../core/services/sub-header.service";
import { SubHeader } from "../../../core/models/sub-header.model";
import { DocumentManagementService } from "../../services/document-management.service";
import { LoaderService } from "../../services/loader.service";
import { OnBaseQueryModel, QueryResult } from "../../models/onBaseIntegrationAndMapping.model";
import { PageData } from "../../models/paging.model";
import { DocumentSearchResultsComponent } from "./document-search-results/document-search-results.component";
import { SortArgs, SortAttribute, SortDirection } from "../../../core/models/sort.model";

@Component({
    selector: 'app-document-search',
    templateUrl: './document-search.component.html',
    styleUrls: ['./document-search.component.scss'],
    standalone: false
})
export class DocumentSearchComponent implements OnInit, OnDestroy {

    errorDialog: Dialog = new Dialog("An error has occurred.", [new DialogButton("OK", false, () => { return; })]);
    noAdditionalResults: Dialog = new Dialog("There are no additional results.", [new DialogButton("OK", false, () => { })]);
    queryModel: OnBaseQueryModel;
    queryResult: QueryResult;
    @ViewChild(DocumentSearchResultsComponent, { static: true }) resultsComponent: DocumentSearchResultsComponent;
    subheader: SubHeader = new SubHeader({ title: "Document Search" });
    subscription: Subscription = new Subscription();

    constructor(public readonly dialogService: DynamicDialogService, public readonly subheaderService: SubHeaderService, public readonly loader: LoaderService, private readonly docService: DocumentManagementService) { }

    ngOnInit() {
        this.subheaderService.updateSubHeader(this.subheader);
    }

    ngOnDestroy() {
        if (this.subscription) this.subscription.unsubscribe();
    }

    doSearch(query: OnBaseQueryModel): void {  
        this.queryModel = query;
        this.loader.toggleLoader(true);
        const obs$ = this.docService.query(query).subscribe(
            (data: QueryResult) => {
                if (data.records.length === 0 && this.queryModel.pageNumber !== 1) {
                    this.noAdditional();
                } else {
                    this.queryResult = data;                    
                }                
                this.loader.toggleLoader(false);
            },
            (error) => {
                this.handleError(error);
            }
        );
        this.subscription.add(obs$);
    }

    handleError(error: any): void {
        console.error(error);
        this.loader.toggleLoader(false);
        this.errorDialog.toggleDialog(true);
        this.dialogService.updateDialog(this.errorDialog);
    }

    newSearch(query: OnBaseQueryModel): void {
        this.queryResult = null;        
        this.doSearch(query);
    }

    noAdditional(): void {
        this.queryModel.pageNumber -= 1;
        this.resultsComponent.pageNumber = this.queryModel.pageNumber;
        this.noAdditionalResults.toggleDialog(true);
        this.dialogService.updateDialog(this.noAdditionalResults);
    }   

    onPageChanged(pagination: PageData): void {
        const newQuery: OnBaseQueryModel = {
            documentTypeIds: this.queryModel.documentTypeIds,
            documentTypeNames: this.queryModel.documentTypeNames,
            matchAll: this.queryModel.matchAll,
            maxResults: this.queryModel.maxResults,
            resultsPerPage: pagination.resultsPerPage,
            displayKeywordTypes: this.queryModel.displayKeywordTypes,
            fromDate: this.queryModel.fromDate,
            toDate: this.queryModel.toDate,
            searchParameters: this.queryModel.searchParameters,
            pageNumber: pagination.pageNumber,
            sort: this.queryModel.sort,
            isAscending: this.queryModel.isAscending
        } as OnBaseQueryModel;
        this.doSearch(newQuery);
    }

    onSorting(args: SortArgs): void {
        let sort: SortAttribute = SortAttribute.DocumentID;
        switch (args.sortProperty.toLocaleLowerCase()) {
            case "document name":
                sort = SortAttribute.DocumentName;
                break;
            case "document type":
                sort = SortAttribute.DocumentTypeName;
                break;
            default:
                sort = SortAttribute.DocumentID;
                break;
        }

        const newQuery: OnBaseQueryModel = {
            documentTypeIds: this.queryModel.documentTypeIds,
            documentTypeNames: this.queryModel.documentTypeNames,
            matchAll: this.queryModel.matchAll,
            maxResults: this.queryModel.maxResults,
            resultsPerPage: this.queryModel.resultsPerPage,
            displayKeywordTypes: this.queryModel.displayKeywordTypes,
            fromDate: this.queryModel.fromDate,
            toDate: this.queryModel.toDate,
            searchParameters: this.queryModel.searchParameters,
            pageNumber: 1,
            isAscending: args.sortDirection === SortDirection.Ascending,
            sort: sort
        } as OnBaseQueryModel;
        this.doSearch(newQuery);
    }
}
